import React from 'react';
import { Box } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const DotGridAsset = ({ maxWidth = '160px', dotRadius = 4, color = '#efefef', ...props }) => (
  <Box maxWidth={maxWidth} width='fit-content' {...props}>
    <motion.div
      initial={{
        opacity: 0,
        scale: 0.8,
        y: 40
      }}
      animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }}
      transition={{
        type: 'spring',
        stiffness: 100,
        damping: 15,
        duration: 0.8,
        delay: 0.6
      }}
    >
      <svg viewBox='0 0 120 180' xmlns='http://www.w3.org/2000/svg' width='100%'>
        {/* Row 1 */}
        <circle cx='20' cy='20' r={dotRadius} fill={color} />
        <circle cx='50' cy='20' r={dotRadius} fill={color} />
        <circle cx='80' cy='20' r={dotRadius} fill={color} />
        <circle cx='110' cy='20' r={dotRadius} fill={color} />

        {/* Row 2 */}
        <circle cx='20' cy='50' r={dotRadius} fill={color} />
        <circle cx='50' cy='50' r={dotRadius} fill={color} />
        <circle cx='80' cy='50' r={dotRadius} fill={color} />
        <circle cx='110' cy='50' r={dotRadius} fill={color} />

        {/* Row 3 */}
        <circle cx='20' cy='80' r={dotRadius} fill={color} />
        <circle cx='50' cy='80' r={dotRadius} fill={color} />
        <circle cx='80' cy='80' r={dotRadius} fill={color} />
        <circle cx='110' cy='80' r={dotRadius} fill={color} />

        {/* Row 4 */}
        <circle cx='20' cy='110' r={dotRadius} fill={color} />
        <circle cx='50' cy='110' r={dotRadius} fill={color} />
        <circle cx='80' cy='110' r={dotRadius} fill={color} />
        <circle cx='110' cy='110' r={dotRadius} fill={color} />

        {/* Row 5 */}
        <circle cx='20' cy='140' r={dotRadius} fill={color} />
        <circle cx='50' cy='140' r={dotRadius} fill={color} />
        <circle cx='80' cy='140' r={dotRadius} fill={color} />
        <circle cx='110' cy='140' r={dotRadius} fill={color} />

        {/* Row 6 */}
        <circle cx='20' cy='170' r={dotRadius} fill={color} />
        <circle cx='50' cy='170' r={dotRadius} fill={color} />
        <circle cx='80' cy='170' r={dotRadius} fill={color} />
        <circle cx='110' cy='170' r={dotRadius} fill={color} />
      </svg>
    </motion.div>
  </Box>
);

export default DotGridAsset;
